import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Badge, Layout, Tabs, Typography} from 'antd';

import VideoTranscript from './Transcript/VideoTranscript';
import QuizQuestionsContainer from './QuizQuestions/QuizQuestionsContainer';

const {Title} = Typography;
const { TabPane } = Tabs;

const VideoPageFeatureMenu = ({updateQuizQuestionAttempt, collapsedTranscript, currentTimestamp, pauseVideo, quizQuestions, seekOnTranscriptClick, seekToVideoTimestamp, transcript}) => {
    const [sidebarWidth, setSidebarWidth] = useState(() => {
        const saved = localStorage.getItem('cugpt-sidebar-width');
        return saved || '30vw';
    });
    const [isResizing, setIsResizing] = useState(false);
    const sidebarRef = useRef(null);
    const isResizingRef = useRef(false);
    const currentWidthRef = useRef(sidebarWidth);
    
    const pendingQuestions = () => {
        let count = 0;
        quizQuestions.forEach(question => {
            if(currentTimestamp >= question.endVideoTimestamp && question.latestAttempt == null){
                count += 1
                return 
            }else{
                return
            }
        })
        return count
        return quizQuestions.length
    }

    useEffect(() => {
        if (isResizing) {
            isResizingRef.current = true;
            document.body.style.cursor = 'col-resize';
            document.body.style.userSelect = 'none';
        } else {
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        }
        return () => {
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
    }, [isResizing]);

    useEffect(() => {
        currentWidthRef.current = sidebarWidth;
    }, [sidebarWidth]);

    const handleResizeStart = (e) => {
        e.preventDefault();
        setIsResizing(true);
    };
    
    return (
        <>
            {isResizing && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 9998,
                        cursor: 'col-resize',
                        pointerEvents: 'auto'
                    }}
                    onMouseMove={(e) => {
                        if (!isResizingRef.current) return;
                        const viewportWidth = window.innerWidth;
                        const newWidthPx = viewportWidth - e.clientX;
                        const newWidthVw = (newWidthPx / viewportWidth) * 100;
                        const constrainedWidth = Math.max(20, Math.min(50, newWidthVw));
                        const newWidth = `${constrainedWidth}vw`;
                        currentWidthRef.current = newWidth;
                        setSidebarWidth(newWidth);
                    }}
                    onMouseUp={() => {
                        if (isResizingRef.current) {
                            isResizingRef.current = false;
                            setIsResizing(false);
                            localStorage.setItem('cugpt-sidebar-width', currentWidthRef.current);
                            document.body.style.cursor = '';
                            document.body.style.userSelect = '';
                        }
                    }}
                />
            )}
            <div style={{ position: 'relative', display: 'flex', height: '100%' }} ref={sidebarRef}>
                {!collapsedTranscript && (
                    <div
                        className="sidebar-resize-handle"
                        onMouseDown={handleResizeStart}
                        style={{
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            bottom: 0,
                            width: '4px',
                            cursor: 'col-resize',
                            zIndex: 1000,
                            backgroundColor: 'transparent',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseEnter={(e) => {
                            if (!isResizing) {
                                e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!isResizing) {
                                e.currentTarget.style.backgroundColor = 'transparent';
                            }
                        }}
                    />
                )}
            <Layout.Sider className={collapsedTranscript ? "" : "visible-transcript-sider"} 
                width={sidebarWidth}
                collapsedWidth={0} 
                collapsible 
                collapsed={collapsedTranscript}
                trigger={null}
            >
                <Tabs defaultActiveKey="1" id='transcript-tab-container' >
                    <TabPane tab={<Badge size="small" count={0}><div style={{padding: "6px 3px 0px 0px"}}>Transcript</div></Badge>}key="1" className='transcript-tab'>
                        <div id='transcript-tab-content'>
                            <VideoTranscript transcript={transcript} videoTimestamp={currentTimestamp} seekOnTranscriptClick={seekOnTranscriptClick}/>
                        </div>
                    </TabPane>
                    
                    <TabPane forceRender tab={<Badge size="small" count={pendingQuestions()}><div style={{padding: "6px 3px 0px 0px"}}>Questions</div></Badge>} key="2" className='transcript-tab'>
                        <div id='transcript-tab-content'>
                            <QuizQuestionsContainer updateQuizQuestionAttempt={updateQuizQuestionAttempt} pauseVideo={pauseVideo} quizQuestions={quizQuestions} seekToVideoTimestamp={seekToVideoTimestamp}/>
                        </div>
                    </TabPane>

                </Tabs>
            </Layout.Sider>
            </div>
        </>
    );
}
export default VideoPageFeatureMenu